// extracted by mini-css-extract-plugin
export var copyIcon = "_rd-2";
export var discountCard = "_rd-0";
export var discountCode = "_rd-3";
export var discountContent = "_rd-1";
export var loadingCard = "_rd-4";